import { getInstance } from './index'
import store from '@/store/store'
import loginService from '@/services/loginService'

function hasUserDto () {
    return !!store.state.auth.vssUserDto
}

function isUserActive () {
    let userDto = store.state.auth.vssUserDto || {}
    return userDto.isActive
}

function userHasRoleList () {
    let userDto = store.state.auth.vssUserDto || {}
    //check if user has roleList or not
    return !!(userDto.roleList && userDto.roleList.length > 0)
}

// function hasAdminAccess () {
//     return userService.isAdministrator()
// }

export const authGuard = (to, from, next) => {
    const authService = getInstance()
    const mainCheck = () => {
        // If the user is authenticated, continue with the route
        if (authService.isAuthenticated) {
            //check if vssDto is loaded
            if (!store.state.auth.vssUserDto) {
                store.dispatch('auth/authenticated').then(() => {
                    return checkRoles()
                })
            } else {
                return checkRoles()
            }
        } else {
            // Otherwise, log in
            authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } })
        }
    }

    const checkRoles = () => {
        if (!hasUserDto()) {
            return next('/login-error?error=server_error&error_description=cannot+obtain+user+information')
        }
        if (loginService.requiresSetup()) {
            return next('/user-setup')
        }
        if (!isUserActive() || !userHasRoleList()) {
            return next('/user-profile')
        }
        if (to.meta && to.meta.requireRoles) {
            let requiredRoles = to.meta.requireRoles
            let userDto = store.state.auth.vssUserDto || {}
            if (!(userDto.roleList && userDto.roleList.some(r => requiredRoles.includes(r)))) {
                alert('User does not have access.')
                return next('/')
            }
        }
        return next()
    }

    // If loading has already finished, check our auth state using `mainCheck()`
    if (!authService.loading) {
        return mainCheck()
    }

    // Watch for the loading property to change before we check isAuthenticated
    authService.$watch('loading', loading => {
        if (loading === false) {
            return mainCheck()
        }
    })
}
